import { UNAUTHENTICATED_ROUTES } from "definitions/constants/routeConstants";
import LoginPage from "pages/Unauthenticated/LoginPage";
import AuthenticatePage from "pages/Unauthenticated/AuthenticatePage";
import UnauthenticatedIntegrationSuccessPage from "pages/Unauthenticated/UnauthenticatedIntegrationSuccessPage";
import { Route } from "./types";

const UNAUTHENTICATED_ROUTES_PERMISSIONS = {
  permission: [],
};

const LOGIN_ROUTE: Route = {
  path: UNAUTHENTICATED_ROUTES.login,
  title: "Login",
  component: <LoginPage />,
  ...UNAUTHENTICATED_ROUTES_PERMISSIONS,
};

const AUTHENTICATE_ROUTE: Route = {
  path: UNAUTHENTICATED_ROUTES.authenticate,
  title: "Authenticate",
  component: <AuthenticatePage />,
  ...UNAUTHENTICATED_ROUTES_PERMISSIONS,
};

const UNAUTHENTICATED_INTEGRATION_SUCCESS_ROUTE: Route = {
  path: UNAUTHENTICATED_ROUTES.integrationSuccess,
  title: "Integration Success",
  component: <UnauthenticatedIntegrationSuccessPage />,
  ...UNAUTHENTICATED_ROUTES_PERMISSIONS,
};

export default [
  AUTHENTICATE_ROUTE,
  LOGIN_ROUTE,
  UNAUTHENTICATED_INTEGRATION_SUCCESS_ROUTE,
];